const envConfig = {
  //app
  appName: 'Practido',
  appFullName: 'Practido Online Olympiad',
  appEmail: 'hello@practido.com',

  //support
  supportEmail: 'hello@practido.com',

  // social links
  facebookLink: 'https://www.facebook.com/profile.php?id=100094743883639',
  twitterLink: 'https://twitter.com/olympiad_p',
  instagramLink: 'https://www.instagram.com/olympiadpracticeapp?igshid=YzVkODRmOTdmMw%3D%3D',
  youtubeLink: 'https://www.youtube.com/@OlympiadPracticeApp',
  whatsappLink: 'https://whatsapp.com/channel/0029Va50kJ33rZZbb9X3za1q',

  // store links
  googlePlayLink: 'https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice',

  appUrl: process.env.REACT_APP_URL || 'http://localhost:3000/',

  backendUrl:
    process.env.REACT_APP_BACKEND_URL ||
    'http://127.0.0.1:5001/naskay-test/us-central1',

  ipInfoKey: process.env.REACT_APP_IPINFO_KEY || '',

  examDuration: Number(50),

  questionSheetId: String(process.env.REACT_APP_QUESTIONS_SHEET_ID || ''),
  fetchQuestionsApi: String(process.env.REACT_APP_FETCH_QUESTIONS || ''),
  emailApi: String(process.env.REACT_APP_EMAIL_API || ''),
};

export default envConfig;
